import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { webUIBaseUrl, webUI } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const pdfService = createApi({
  reducerPath: "pdfService",
  baseQuery: fetchBaseQuery({ baseUrl: webUIBaseUrl }),
  tagTypes: ["Pdf"],
  endpoints: (builder) => ({
    getPdfRecords: builder.mutation({
      query(body) {
        let url = `${webUI.pdfContorller.getPdfRecords}/${body.page}/${body.size}?columnName=${body.sort}`;
        if (body.keyword && body.keyword.trim() !== "") {
          url += `&keyword=${encodeURIComponent(body.keyword)}`;
        }

        return {
          url: url,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    downloadPdf: builder.mutation<Blob, string>({
      query: (fileId) => ({
        url: `${webUI.pdfContorller.downloadPdf}/${fileId}`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useGetPdfRecordsMutation,
  useDownloadPdfMutation,
} = pdfService;